// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25686fa9","488":"f549d066","732":"e0928d4a","977":"0e6d6a81"}[chunkId] + ".chunk.js";
};